import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { stateDistrictWise } from ".././../utils/api-urls";

const StateDistrictTable = () => {
  const [rowData, setRowData] = useState([]);
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const stateDistrictData = await fetch(stateDistrictWise);
    const stateDistrictDataJson = await stateDistrictData.json();
    console.log(Object.keys(stateDistrictDataJson));
    let allStateStats = [];
    for (let state of Object.keys(stateDistrictDataJson)) {
      let stateStats = getStateData(stateDistrictDataJson[state]);
      stateStats.name = state;
      allStateStats.push(stateStats);
    }
    let sortedStates = allStateStats.sort((a, b) => b.confirmed - a.confirmed);
    console.log(sortedStates);
    setRowData(sortedStates);
  };

  const getStateData = (districts) => {
    let stateStats = { active: 0, confirmed: 0, deceased: 0, recovered: 0 };
    let districtsNameArray = Object.keys(districts.districtData);
    for (let district of districtsNameArray) {
      stateStats.confirmed += districts.districtData[district].confirmed;
      stateStats.active += districts.districtData[district].active;
      stateStats.recovered += districts.districtData[district].recovered;
      stateStats.deceased += districts.districtData[district].deceased;
    }
    return stateStats;
  };

  const columnDefs = [
    { headerName: "State", field: "name", sortable: true },
    { headerName: "Confirmed", field: "confirmed", sortable: true },
    { headerName: "Active", field: "active", sortable: true },
    { headerName: "Recovered", field: "recovered", sortable: true },
    { headerName: "Deceased", field: "deceased", sortable: true },
  ];

  return (
    <div className="states-stats">
      <div
        className="ag-theme-material"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact columnDefs={columnDefs} rowData={rowData}></AgGridReact>
      </div>
    </div>
  );
};

export default StateDistrictTable;
